// 🆕 [Phase 56.3] Extrait de CalendrierProduction.jsx — popup "Fermer le rendez-vous de soumission".
// Ouvert quand on clique sur un RDV de soumission dans le calendrier. Permet de marquer
// la visite comme effectuée → dossier passe en "Soum. à faire".
//
// Payload data (rdvPopup) : { id, titre?, date, heure_debut?, notes? }
import { CheckCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function DialogRdvVisiteEffectuee({ data, onClose, onConfirm }) {
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Fermer le rendez-vous de soumission</DialogTitle>
          <DialogDescription>
            {data?.titre || 'RDV de soumission'}
          </DialogDescription>
        </DialogHeader>
        {data && (
          <div className="space-y-3 text-sm">
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
              <p className="font-medium text-orange-800">{data.date} {data.heure_debut ? `à ${data.heure_debut}` : ''}</p>
              {data.notes && <p className="text-xs text-orange-600 mt-1">{data.notes}</p>}
            </div>
            <p className="text-gray-600 text-xs">
              En confirmant, le dossier passera en <strong>&quot;Soum. à faire&quot;</strong> et le délai de 5 jours ouvrables commencera.
            </p>
          </div>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" size="sm" onClick={onClose}>Annuler</Button>
          <Button
            size="sm"
            className="bg-indigo-600 hover:bg-indigo-700"
            data-testid="btn-visite-effectuee-prod"
            onClick={onConfirm}
          >
            <CheckCircle className="w-4 h-4 mr-1" /> Visite effectuée
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DialogRdvVisiteEffectuee;
